import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";

export default function ModalAdquiraFlex({ show, setShow }) {

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://app-cdn.clickup.com/assets/js/forms-embed/v1.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Modal
      show={show}
      onHide={setShow}
      centered
      dialogClassName="modal-clickup"
    >
      <Modal.Header closeButton>
        <Modal.Title>Formulário de contato</Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-0">
        <iframe
          className="clickup-embed clickup-dynamic-height"
          src="https://ead.novelconsultoria.com.br/#/formulario?token=XR-98x_gih5adtZZU_Ertm1m"
          width="100%"
          style={{
            background: "transparent",
            border: "none"
          }}
        />
      </Modal.Body>
    </Modal>
  );
}